import camelCase from 'lodash/camelCase';

/**
 * Formats the progress status for the updateProgress reducer.
 * Converts Pascal case React component name to camel case JSON
 * object key, then sets the status as the JSON object value.
 *
 * @param {String} componentName React component name in Pascal case.
 * @returns {Object} Progress status for specified component.
 */
export const formatProgress = (componentName, status) => {
  const progress = {};
  progress[camelCase(componentName)] = status;
  return(progress);
};
